<template>
  <div>
    <b-button size="sm" variant="success" v-b-modal.modal-1
      >New Announcement</b-button
    >
    <b-modal id="modal-1" title="Register Annoucement">
      <b-alert variant="success" v-if="success" show> {{ success }}</b-alert>
      <b-form @submit.prevent="submitForm" enctype="multipart/form-data">
        <b-form-group
          id="input-group-2"
          label="Assignment Level:"
          label-for="input-2"
        >
          <select
            name=""
            id=""
            class="form-control"
            v-model="form.assignment_level"
            @change="AssignmentLevelChange"
          >
            <option value="">Select Assignment</option>
            <option value="general">General</option>
            <option value="project_level">Project Level</option>
            <option value="zone_level">Zone Level</option>
            <option value="plot_level">Plot Level</option>
          </select>
        </b-form-group>

        <div
          v-if="
            form.assignment_level === 'project_level' ||
            form.assignment_level === 'zone_level' ||
            form.assignment_level === 'plot_level'
          "
        >
          <b-form-group
            id="input-group-2"
            label="Projects:"
            label-for="input-2"
          >
            <select
              name=""
              id=""
              class="form-control"
              v-model="form.project_id"
              @change="projectChange"
              :disabled="!showSocialMediaDetails"
            >
              <option value="">Select Project</option>
              <option
                :value="project._id"
                v-for="(project, index) in projects"
                :key="index"
              >
                {{ project.name }}
              </option>
            </select>
          </b-form-group>
        </div>

        <div
          v-if="
            form.assignment_level === 'plot_level' ||
            form.assignment_level === 'zone_level'
          "
        >
          <b-form-group id="input-group-2" label="Zone:" label-for="input-2">
            <select
              name=""
              id=""
              class="form-control"
              v-model="form.zone_id"
              @change="zoneChange"
              :disabled="!showSocialMediaDetails"
            >
              <option value="">Select Zone</option>
              <option
                :value="zone._id"
                v-for="(zone, index) in zones"
                :key="index"
              >
                {{ zone.code }}
              </option>
            </select>
          </b-form-group>
        </div>

        <div v-if="form.assignment_level === 'plot_level'">
          <b-form-group id="input-group-2" label="Plot:" label-for="input-2">
            <select name="" id="" class="form-control" v-model="form.plot_id">
              <option value="">Select Plot</option>
              <option
                :value="plot._plot_id._id"
                v-for="(plot, index) in plots"
                :key="index"
              >
                {{ plot._plot_id.code }}
              </option>
            </select>
          </b-form-group>
        </div>

        <template v-if="!showSocialMediaDetails">
          <h5>{{ showSocialMediaAlignmentDetails }}</h5>

          <b-form-group id="input-group-1" label="Title:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="form.title"
              type="text"
              placeholder="Enter Title"
              required
              :state="isNameValid"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-2"
            label="Description:"
            label-for="input-2"
          >
            <b-form-textarea
              id="input-2"
              v-model="form.description"
              placeholder="Enter description..."
              rows="5"
              max-rows="8"
              :state="isDescriptionValid"
            ></b-form-textarea>
          </b-form-group>

          <!-- URL field - disabled in PDF mode -->
          <b-form-group id="input-group-2" label="URL:" label-for="input-2">
            <b-form-input
              id="input-2"
              :state="getURLFieldState"
              v-model="form.url"
              placeholder="Enter URL"
              :disabled="isPDFMode"
            ></b-form-input>
          </b-form-group>

          <!-- Loom checkbox - disabled in PDF mode -->
          <b-form-group id="input-group-loom">
            <b-form-checkbox
              id="loom-checkbox"
              v-model="form.isLoomVideo"
              :value="true"
              :unchecked-value="false"
              :disabled="isPDFMode"
            >
              Loom Video
            </b-form-checkbox>
          </b-form-group>

          <!-- Cover Image - always required in PDF mode -->
          <b-form-group
            id="input-group-2"
            :label="isPDFMode ? 'Cover Image (Required):' : 'Cover Image:'"
            description=".jpeg and .png format image file is allowed less than 5mb "
            label-for="input-2"
          >
            <b-form-file
              v-model="form.cover_image"
              id="file"
              ref="file"
              accept=".jpeg,.png"
              :state="getImageFieldState()"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              @change="validateCoverImage"
            ></b-form-file>
          </b-form-group>

          <!-- Images field - disabled in PDF mode -->
          <b-form-group id="input-group-3" label="Images" label-for="input-3">
            <b-form-file
              accept="image/*"
              multiple
              id="file2"
              ref="file2"
              v-model="form.images"
              placeholder="Choose up to 5 images or drop them here..."
              drop-placeholder="Drop file here..."
              @change="validateImages"
              :disabled="isPDFMode"
            ></b-form-file>
          </b-form-group>

          <!-- Videos field - disabled in PDF mode -->
          <b-form-group
            id="input-group-3"
            label="Videos"
            label-for="input-4"
            description="Video file is allowed less than 50mb each"
          >
            <b-form-file
              multiple
              id="file3"
              ref="file3"
              v-model="form.videos"
              accept="video/*"
              placeholder="Choose up to 3 videos or drop them here..."
              drop-placeholder="Drop file here..."
              @change="validateVideos"
              :disabled="isPDFMode"
            ></b-form-file>
          </b-form-group>

          <!-- PDFs field - : disabled when URL, images, or videos are present -->
          <b-form-group
            id="input-group-3"
            label="PDFs"
            label-for="input-4"
            description="PDF file is allowed less than 100mb "
          > <b-form-file
      multiple
      id="file4"
      ref="file4"
      v-model="form.pdfs"
      accept=".pdf,application/pdf"
      placeholder="Choose PDFs or drop them here..."
      drop-placeholder="Drop PDF files here..."
      @change="validatePDFs"
      :disabled="isPDFFieldDisabled"
    ></b-form-file>

    <!-- Clear Button -->
    <b-button
      v-if="form.pdfs && form.pdfs.length > 0"
      variant="danger"
      class="mt-2 "
       size="sm"
      @click="clearPDFs"
    >
      Clear PDF
    </b-button>

            <!-- Selected PDFs List -->
            <!-- <div v-if="form.pdfs && form.pdfs.length > 0" class="mt-3">
              <div
                v-for="(pdf, index) in form.pdfs"
                :key="'pdf-' + index"
                class="pdf-item d-flex justify-content-between align-items-center mb-2"
              >
                <div>
                  <span>
                    <i class="mr-2"></i>
                    {{ pdf.name }}
                  
                  </span>
                </div>
                <button
                  type="button"
                  @click="removePDF(index)"
                  class="btn btn-sm btn-outline-danger"
                  title="Remove this PDF"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div> -->

            <div v-if="isPDFFieldDisabled && !isPDFMode" class="mt-2">
              <small class="text-muted">
                <i class="fas fa-info-circle mr-1"></i>
                PDF upload is disabled when URL, images, or videos are present.
              </small>
            </div>
          </b-form-group>

          <b-row>
            <b-col cols="12" class="d-flex justify-content-center">
              <b-spinner
                class="text-center"
                v-if="isUploading"
                variant="success"
                type="grow"
                label="Uploading..."
              ></b-spinner>
            </b-col>
          </b-row>
        </template>
      </b-form>
      <template #modal-footer="{ ok, close }">
        <b-button
          size="sm"
          variant="success"
          @click="submitForm()"
          :disabled="isDisable"
        >
          Register
        </b-button>
        <b-button size="sm" variant="danger" @click="close()"> Close </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projects: [],
      zones: [],
      plots: [],
      form: {
        title: "",
        description: "",
        url: "",
        cover_image: null,
        images: null,
        videos: null,
        assignment_level: "",
        project_id: "",
        zone_id: "",
        plot_id: "",
        isLoomVideo: false,
        pdfs: null,
      },
      isPDFMode: false,
      success: false,
      isDisable: false,
      isUploading: false,
    };
  },
  created() {
    this.getProjects();
  },

  computed: {
    isNameValid() {
      return this.form.title.length > 0;
    },

    isDescriptionValid() {
      return this.form.description.length > 0;
    },

    showSocialMediaDetails() {
      if (this.form.assignment_level === "project_level") {
        return !this.form.project_id;
      } else if (this.form.assignment_level === "zone_level") {
        return !this.form.zone_id;
      } else if (this.form.assignment_level === "general") {
        return false;
      } else if (this.form.assignment_level === "plot_level") {
        return !this.form.plot_id;
      } else {
        return true;
      }
    },

    showSocialMediaAlignmentDetails() {
      if (this.form.assignment_level === "project_level") {
        return "Project Level Announcement";
      } else if (this.form.assignment_level === "zone_level") {
        return "Zone Level  Announcement";
      } else if (this.form.assignment_level === "plot_level") {
        return "Plot Level Announcement";
      } else if (this.form.assignment_level === "general") {
        return "General  Announcement";
      } else {
        return true;
      }
    },

    getURLFieldState() {
      if (this.form.isLoomVideo) {
        if (!this.form.url) {
          return false;
        }
        return this.validateLoomURL() ? true : false;
      }
      return null;
    },

    isPDFFieldDisabled() {
      const hasURL = this.form.url && this.form.url.trim().length > 0;

      const hasImages = this.form.images && this.form.images.length > 0;

      const hasVideos = this.form.videos && this.form.videos.length > 0;

      return hasURL || hasImages || hasVideos;
    },

    isOtherFieldsDisabled() {
      return this.isPDFMode;
    },
  },

  watch: {
    "form.url"(newVal) {
      const hasURL = newVal && newVal.trim().length > 0;

      if (hasURL) {
        this.clearPDFs();
      }
    },

    "form.images"(newVal) {
      const hasImages = newVal && newVal.length > 0;

      if (hasImages) {
        this.clearPDFs();
      }
    },

    "form.videos"(newVal) {
      const hasVideos = newVal && newVal.length > 0;

      if (hasVideos) {
        this.clearPDFs();
      }
    },

    "form.isLoomVideo"(newVal) {
      if (newVal) {
        this.clearPDFs();
      }
    },

    "form.pdfs"(newVal) {
      if (newVal && newVal.length > 0) {
        this.enablePDFMode();
      } else {
        this.isPDFMode = false;
      }
    },
  },

  methods: {
    clearPDFs() {
      if (this.form.pdfs && this.form.pdfs.length > 0) {
        this.form.pdfs = null;
        this.isPDFMode = false;
        this.$refs.file4?.reset();
      }
    },

    clearOtherFields() {
      this.form.url = "";
      this.form.isLoomVideo = false;
      this.form.images = null;
      this.form.videos = null;
      this.$refs.file2?.reset();
      this.$refs.file3?.reset();
    },

    enablePDFMode() {
      this.isPDFMode = true;
      this.clearOtherFields();
    },

    disablePDFMode() {
      if (this.isPDFMode) {
        this.isPDFMode = false;
        this.form.pdfs = null;
        this.$refs.file4?.reset();
      }
    },

    getImageFieldState() {
      if (this.isPDFMode) {
        return Boolean(this.form.cover_image);
      }

      if (this.form.isLoomVideo) {
        return null;
      }
      return Boolean(this.form.cover_image);
    },

    validateLoomURL() {
      if (this.form.isLoomVideo && this.form.url) {
        return this.form.url.startsWith(process.env.VUE_APP_LOOM_BASEURL);
      }
      return true;
    },

    getProjects() {
      window.axios.get("project").then((resp) => {
        this.projects = resp.data.data;
      });
    },

    AssignmentLevel() {
      (this.zones = []), (this.plots = []), (this.form.project_id = "");
      this.form.zone_id = "";
      this.form.plot_id = "";
      window.axios.get("project").then((resp) => {
        this.projects = resp.data.data;
      });
    },

    AssignmentLevelChange() {
      this.getProjects();
      this.zones = [];
      this.plots = [];
      this.projects = [];
      this.form.zone_id = "";
      this.form.plot_id = "";
      this.form.project_id = "";
      let assignment_level = this.form.assignment_level;
      if (
        assignment_level === "zone_level" ||
        assignment_level === "plot_level"
      ) {
        this.selectedProject = this.projects.filter((number) => {
          return number._id === this.form.project_id ? number.name : false;
        });
        window.axios
          .get("/project-zones/" + this.form.project_id)
          .then((resp) => {
            this.zones = resp.data.data;
          });
      }
    },

    projectChange() {
      (this.zones = []), (this.plots = []);
      this.form.zone_id = "";
      this.form.plot_id = "";
      let assignment_level = this.form.assignment_level;
      if (
        assignment_level === "zone_level" ||
        assignment_level === "plot_level"
      ) {
        this.selectedProject = this.projects.filter((number) => {
          return number._id === this.form.project_id ? number.name : false;
        });
        window.axios
          .get("/project-zones/" + this.form.project_id)
          .then((resp) => {
            this.zones = resp.data.data;
          });
      }
    },

    zoneChange() {
      let assignment_level = this.form.assignment_level;
      if (
        assignment_level === "project_level" ||
        assignment_level === "plot_level"
      ) {
        this.selectedZone = this.zones.filter((number) => {
          return number._id === this.form.zone_id ? number.code : false;
        });
        window.axios
          .get("/all-plots-assigned/" + this.form.zone_id)
          .then((resp) => {
            this.plots = resp.data.data;
          });
      }
    },

    validateCoverImage(event) {
      const file = event.target.files[0];
      if (file) {
        const maxSize = 5 * 1024 * 1024; // 5MB in bytes
        if (file.size > maxSize) {
          alert("Cover image file size must not exceed 5 MB.");
          this.$refs["file"].reset();
          this.form.cover_image = null;
          return;
        }
        this.form.cover_image = file;
      }
    },

    validateImages(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        const maxSize = 10 * 1024 * 1024; // 10MB per image
        const maxTotalImages = 5; // Maximum 5 images allowed

        if (files.length > maxTotalImages) {
          alert(
            `Maximum ${maxTotalImages} images allowed. You selected ${files.length} images.`
          );
          this.$refs["file2"].reset();
          this.form.images = null;
          return;
        }

        for (let i = 0; i < files.length; i++) {
          if (files[i].size > maxSize) {
            alert(`Image ${files[i].name} size must not exceed 10 MB.`);
            this.$refs["file2"].reset();
            this.form.images = null;
            return;
          }
        }
        this.form.images = files;
      }
    },

    validateVideos(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        const maxSize = 50 * 1024 * 1024; // 50MB per video
        const maxTotalVideos = 3; // Maximum 3 videos allowed

        if (files.length > maxTotalVideos) {
          alert(
            `Maximum ${maxTotalVideos} videos allowed. You selected ${files.length} videos.`
          );
          this.$refs["file3"].reset();
          this.form.videos = null;
          return;
        }

        for (let i = 0; i < files.length; i++) {
          if (files[i].size > maxSize) {
            alert(`Video ${files[i].name} size must not exceed 50 MB.`);
            this.$refs["file3"].reset();
            this.form.videos = null;
            return;
          }
        }
        this.form.videos = files;
      }
    },

    validatePDFs(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        const maxSize = 100 * 1024 * 1024; // 100MB per PDF
        const maxTotalPDFs = 1; // Maximum 1 PDF allowed

        if (files.length > maxTotalPDFs) {
          alert(
            `Maximum ${maxTotalPDFs} PDFs allowed. You selected ${files.length} PDFs.`
          );
          this.$refs["file4"].reset();
          this.form.pdfs = null;
          return;
        }

        for (let i = 0; i < files.length; i++) {
          if (files[i].size > maxSize) {
            alert(`PDF ${files[i].name} size must not exceed 5 MB.`);
            this.$refs["file4"].reset();
            this.form.pdfs = null;
            return;
          }
        }
        this.form.pdfs = files;
      }
    },

    removePDF(index) {
      if (this.form.pdfs && this.form.pdfs.length > 0) {
        let pdfArray = Array.from(this.form.pdfs);
        pdfArray.splice(index, 1);

        if (pdfArray.length === 0) {
          this.form.pdfs = null;
          this.isPDFMode = false;
          this.$refs["file4"].reset();
        } else {
          const dt = new DataTransfer();
          pdfArray.forEach((file) => dt.items.add(file));
          this.form.pdfs = dt.files;
        }
      }
    },

    submitForm() {
      let validationErrors = [];

      if (this.form.title.length === 0) {
        validationErrors.push("Title");
      }

      if (this.form.description.length === 0) {
        validationErrors.push("Description");
      }

      if (this.isPDFMode) {
        if (!this.form.cover_image) {
          validationErrors.push("Cover Image (required in PDF mode)");
        }

        if (!this.form.pdfs || this.form.pdfs.length === 0) {
          validationErrors.push("PDFs");
        }
      } else {
        let fileState = Boolean(this.form.cover_image);
        let urlRequired = this.form.isLoomVideo;
        let coverImageRequired = !this.form.isLoomVideo;

        if (
          urlRequired &&
          (!this.form.url || this.form.url.trim().length === 0)
        ) {
          validationErrors.push("URL");
        }

        if (
          urlRequired &&
          this.form.url &&
          this.form.url.trim().length > 0 &&
          !this.validateLoomURL()
        ) {
          validationErrors.push("Invalid Loom URL");
        }

        if (coverImageRequired && !fileState) {
          validationErrors.push("Cover Image");
        }
      }

      if (validationErrors.length > 0) {
        this.$bvToast.toast(
          `${validationErrors.join(", ")} ${
            validationErrors.length === 1 ? "is" : "are"
          } required!`,
          {
            title: `Error`,
            variant: "danger",
            solid: true,
          }
        );
        return;
      }

      let resp = confirm("Are you sure you want to create event ?");

      if (resp) {
        let formData = new FormData();

        formData.append("title", this.form.title);
        formData.append("description", this.form.description);
        formData.append("assignment_level", this.form.assignment_level);
        formData.append("project_id", this.form.project_id);
        formData.append("zone_id", this.form.zone_id);
        formData.append("plot_id", this.form.plot_id);

        if (this.form.cover_image) {
          formData.append("image", this.form.cover_image);
        }

        if (this.isPDFMode) {
          formData.append("url", "");
          formData.append("isLoomVideo", false);

          if (this.form.pdfs && this.form.pdfs.length > 0) {
            for (let i = 0; i < this.form.pdfs.length; i++) {
              formData.append("pdfs", this.form.pdfs[i]);
            }
          }
        } else {
          formData.append("url", this.form.url);
          formData.append("isLoomVideo", this.form.isLoomVideo);

          if (this.form.images && this.form.images.length > 0) {
            for (let i = 0; i < this.form.images.length; i++) {
              formData.append("images", this.form.images[i]);
            }
          }

          if (this.form.videos && this.form.videos.length > 0) {
            for (let i = 0; i < this.form.videos.length; i++) {
              formData.append("videos", this.form.videos[i]);
            }
          }

          if (this.form.pdfs && this.form.pdfs.length > 0) {
            for (let i = 0; i < this.form.pdfs.length; i++) {
              formData.append("pdfs", this.form.pdfs[i]);
            }
          }
        }

        this.isDisable = true;
        this.isUploading = true;

        this.$apiV2
          .post("announcements", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((resp) => {
            if (resp.data.success) {
              this.success = "Announcement created successfully!";

              this.form.title = "";
              this.form.description = "";
              this.form.url = "";
              this.form.cover_image = null;
              this.form.images = null;
              this.form.videos = null;
              this.form.pdfs = null;
              this.form.isLoomVideo = false;
              this.form.assignment_level = "";
              this.form.project_id = "";
              this.form.zone_id = "";
              this.form.plot_id = "";
              this.zones = [];
              this.plots = [];
              this.isPDFMode = false;

              this.$refs.file?.reset();
              this.$refs.file2?.reset();
              this.$refs.file3?.reset();
              this.$refs.file4?.reset();

              this.$emit("socialMediaCreateEvent", resp.data);
              this.isDisable = false;
              this.isUploading = false;
              setTimeout(() => (this.success = false), 3000);
            }
          })
          .catch((err) => {
            console.error("Error creating social media post:", err);
            this.isDisable = false;
            this.isUploading = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.list-group-item {
  transition: none;
}
</style>
